import { Layout } from "../../../components/Layout";
import BusinessNav from "../BusinessNav";
import BusinessNotificationForm from "./BusinessNotificationForm";

const BusinessNotification = () => {
    return(
        <Layout>
            <BusinessNav />
            <BusinessNotificationForm />
        </Layout>
    )
}
export default BusinessNotification;